/* global globalThis */
(function atlasQuoteRequestBootstrap(global) {
  "use strict";

  var LIMITS = Object.freeze({
    manufacturer: 120,
    mpn: 160,
    title: 240,
    productUrl: 500,
    atlasId: 80,
    items: 3000,
    returnUrl: 200,
  });
  var QUOTE_SUCCESS_RETURN_TO = "/pages/contact?atlas_request=quote&mode=success";

  function bounded(value, maximum) {
    return String(value || "").trim().slice(0, maximum);
  }

  function normalizedQuantity(value) {
    var parsed = Number(value);
    return Number.isInteger(parsed) && parsed >= 1 && parsed <= 9999
      ? String(parsed)
      : "1";
  }

  function safeProductUrl(value, origin) {
    var candidate = bounded(value, LIMITS.productUrl);
    if (!candidate) return "";
    try {
      var parsed = new URL(candidate, origin);
      if (parsed.origin !== origin || !parsed.pathname.startsWith("/products/")) {
        return "";
      }
      parsed.hash = "";
      return parsed.href;
    } catch (_error) {
      return "";
    }
  }

  function safeReturnUrl(value) {
    var candidate = bounded(value, LIMITS.returnUrl);
    return candidate === "/cart" || /^\/products\/[a-z0-9][a-z0-9-]*$/i.test(candidate)
      ? candidate
      : "/cart";
  }

  function parseQuoteContext(search, origin) {
    var params = new URLSearchParams(search || "");
    var requested = params.get("atlas_request") === "quote";
    var requestedMode = params.get("mode") === "product"
      ? "product"
      : params.get("mode") === "shipping"
        ? "shipping"
      : params.get("mode") === "success"
        ? "success"
        : "general";
    var manufacturer = bounded(params.get("manufacturer"), LIMITS.manufacturer);
    var mpn = bounded(params.get("mpn"), LIMITS.mpn);
    var title = bounded(params.get("title"), LIMITS.title);
    var productUrl = safeProductUrl(params.get("product_url"), origin);
    var atlasId = bounded(params.get("atlas_id"), LIMITS.atlasId);
    if (atlasId && !/^(?:SL-[A-Z0-9]+|SHOPIFY-[0-9]+|BOBRICK-FUTURE-[A-Z0-9]+)$/i.test(atlasId)) atlasId = "";
    var items = bounded(params.get("items"), LIMITS.items);
    var returnUrl = safeReturnUrl(params.get("return_url"));

    var hasProductIdentity = Boolean(manufacturer && mpn && title);
    var mode = requested && requestedMode === "product" && hasProductIdentity
      ? "product"
      : requested && requestedMode === "shipping" && (hasProductIdentity || items)
        ? "shipping"
      : requested && requestedMode === "success"
        ? "success"
        : requested
          ? "general"
          : "contact";

    return {
      mode: mode,
      manufacturer: manufacturer,
      mpn: mpn,
      title: title,
      productUrl: productUrl,
      quantity: normalizedQuantity(params.get("quantity")),
      atlasId: atlasId,
      items: items || (hasProductIdentity ? `${title} — ${mpn} × ${normalizedQuantity(params.get("quantity"))}` : ""),
      returnUrl: returnUrl,
    };
  }

  function returnTargetForMode(mode) {
    return mode === "product" || mode === "general" || mode === "shipping"
      ? QUOTE_SUCCESS_RETURN_TO
      : "back";
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  function setValue(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.value = value;
  }

  function toggle(root, selector, visible) {
    root.querySelectorAll(selector).forEach(function updateVisibility(element) {
      element.hidden = !visible;
    });
  }

  function enable(root, selector, enabled) {
    root.querySelectorAll(selector).forEach(function updateEnabled(element) {
      element.disabled = !enabled;
    });
  }

  function initialize(root) {
    if (root.dataset.atlasQuoteReady === "true") return;
    root.dataset.atlasQuoteReady = "true";

    var context = parseQuoteContext(global.location.search, global.location.origin);
    var effectiveMode = context.mode;
    var isQuoteSuccess = effectiveMode === "success";
    var isQuote = effectiveMode !== "contact";
    var isProduct = effectiveMode === "product";
    var isGeneral = effectiveMode === "general";
    var isShipping = effectiveMode === "shipping";
    root.dataset.atlasContactMode = effectiveMode;

    toggle(root, "[data-atlas-contact-only]", !isQuote);
    toggle(root, "[data-atlas-quote-only]", isQuote);
    toggle(root, "[data-atlas-product-only]", isProduct);
    toggle(root, "[data-atlas-general-only]", isGeneral);
    toggle(root, "[data-atlas-shipping-only]", isShipping);
    toggle(root, "[data-atlas-quote-entry-only]", isQuote && !isQuoteSuccess);
    toggle(root, "[data-atlas-quote-success-only]", isQuoteSuccess);
    toggle(root, "[data-atlas-entry-only]", !isQuoteSuccess);
    enable(root, "[data-atlas-quote-field]", isQuote);
    enable(root, "[data-atlas-product-field]", isProduct);
    enable(root, "[data-atlas-general-field]", isGeneral);
    enable(root, "[data-atlas-shipping-field]", isShipping);

    root.querySelectorAll("[data-atlas-quote-required]").forEach(function setRequired(field) {
      field.required = isQuote;
      field.setAttribute("aria-required", isQuote ? "true" : "false");
    });
    var quantityField = root.querySelector("[data-atlas-quantity]");
    if (quantityField) {
      quantityField.value = context.quantity;
      quantityField.required = isProduct;
      quantityField.setAttribute("aria-required", isProduct ? "true" : "false");
    }

    var returnTo = root.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = returnTargetForMode(effectiveMode);

    setValue(root, "[data-atlas-request-type]", isProduct
      ? "ATLAS QUOTE REQUEST — PRODUCT"
      : isShipping
        ? "ATLAS SHIPPING CONFIRMATION REQUEST"
        : isGeneral
          ? "ATLAS QUOTE REQUEST — GENERAL / PROJECT"
          : "");
    setValue(root, "[data-atlas-manufacturer-field]", context.manufacturer);
    setValue(root, "[data-atlas-mpn-field]", context.mpn);
    setValue(root, "[data-atlas-title-field]", context.title);
    setValue(root, "[data-atlas-url-field]", context.productUrl);
    setValue(root, "[data-atlas-id-field]", context.atlasId);
    setValue(root, "[data-atlas-return-url-field]", context.returnUrl);
    setValue(root, "[data-atlas-shipping-items]", context.items);
    setText(root, "[data-atlas-manufacturer-text]", context.manufacturer);
    setText(root, "[data-atlas-mpn-text]", context.mpn);
    setText(root, "[data-atlas-title-text]", context.title);

    var productLink = root.querySelector("[data-atlas-product-link]");
    if (productLink) {
      productLink.hidden = !context.productUrl;
      if (context.productUrl) productLink.href = context.productUrl;
      else productLink.removeAttribute("href");
    }
    var returnLink = root.querySelector("[data-atlas-return-link]");
    if (returnLink) {
      returnLink.href = context.returnUrl;
      returnLink.textContent = context.returnUrl.startsWith("/products/") ? "Back to product" : "Back to cart";
    }

    var heading = root.querySelector("[data-atlas-form-heading]");
    if (heading) {
      heading.textContent = isQuoteSuccess
        ? "Quote Request Received"
        : isShipping
          ? "Request Shipping Confirmation"
        : isQuote
          ? "Request a Quote"
          : "Contact Atlas";
    }
    var submit = root.querySelector("[data-atlas-submit]");
    if (submit) submit.textContent = isShipping ? "Send Shipping Request" : isQuote ? "Send Quote Request" : "Submit";

    var successTitle = root.querySelector("[data-atlas-success-title]");
    var successBody = root.querySelector("[data-atlas-success-body]");
    if (successTitle && isQuote) successTitle.textContent = "Quote Request Received";
    if (successBody && isQuote) {
      successBody.textContent = "Atlas has received the quote request.";
    }
  }

  var api = Object.freeze({
    limits: LIMITS,
    normalizedQuantity: normalizedQuantity,
    parseQuoteContext: parseQuoteContext,
    quoteSuccessReturnTo: QUOTE_SUCCESS_RETURN_TO,
    returnTargetForMode: returnTargetForMode,
    safeProductUrl: safeProductUrl,
  });
  global.AtlasQuoteRequestV1 = api;

  if (global.document) {
    global.document.querySelectorAll("[data-atlas-quote-request]").forEach(initialize);
    global.document.addEventListener("shopify:section:load", function onSectionLoad(event) {
      var root = event.target.querySelector("[data-atlas-quote-request]");
      if (root) initialize(root);
    });
  }
})(typeof window === "undefined" ? globalThis : window);
